import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { mapSocketFactory } from '../../utils/socketFactory';
import { setIsWhiteboardActive, setWhiteboardId, setNotificationActive, CHECK_WHITEBOARD_STATUS } from './store/whiteboardSlice';
import WhiteboardNotification from './components/WhiteboardNotification/WhiteboardNotification';
import { resetWhiteboard } from './store/whiteboardThunks';

export default function WhiteBoardManager() {
    const dispatch = useDispatch();
    const { currentRoom } = useSelector((state) => state.MapDisplay);
    const { notificationActive, whiteboardActive } = useSelector((state) => state.whiteboard);


    const closeWhiteboard = useCallback(() => {
        if (whiteboardActive) {
            dispatch(setIsWhiteboardActive(false));
            dispatch(setWhiteboardId(null));
        }
    }, [whiteboardActive, dispatch]);
    const closeWhiteboardRef = useRef(closeWhiteboard);

    useEffect(() => {
        closeWhiteboardRef.current = closeWhiteboard;
    }, [closeWhiteboard]);


    useEffect(() => {
        if (!currentRoom?.room_id) {
            console.warn("[WhiteBoardListener] No room ID found, cannot subscribe.");
            return;
        }

        const eventName = `whiteboardStatusChanged-${currentRoom.room_id}`;
        console.log("[WhiteBoardListener] Subscribing to:", eventName);

        const socket = mapSocketFactory.socket;
        if (!socket) {
            console.error("[WhiteBoardListener] Socket not ready in factory!");
            return;
        }

        const handleStatusChange = (data) => {
            console.log("[WhiteBoardListener] Dispatching active:", data.active);
            dispatch(setIsWhiteboardActive(data.active));
            console.log("[WhiteBoardListener] Dispatching boardId:", data.boardId);
            dispatch(setWhiteboardId(data.boardId));
        };

        socket.on(eventName, handleStatusChange);
        dispatch(CHECK_WHITEBOARD_STATUS({ roomId: currentRoom.room_id }));

        return () => {
            socket.off(eventName, handleStatusChange);
            closeWhiteboardRef.current();
            console.log("[WhiteBoardListener] Unsubscribed from:", eventName);

        };
    }, [currentRoom?.room_id, dispatch]);

    const handleReset = () => {
        dispatch(resetWhiteboard());
        dispatch(setNotificationActive(false));
    }


    return <WhiteboardNotification
        active={notificationActive}
        onClose={() => dispatch(setNotificationActive(false))}
        onReset={handleReset}
    />;
}